
import React from 'react';

export const IdentificationIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    badge
  </span>
);